<template>
  <v-card dark>
    <v-card-title class="d-flex justify-space-between">
      <div>
        <span>Configurações da API</span>
      </div>
      <div>
        <v-icon>mdi-power-plug-outline</v-icon>
      </div>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col xl="12" lg="12" md="12" sm="12">
          <v-data-table
            dark
            dense
            :items="cmpIntegrationsList"
            :headers="integrationsHeader"
            hide-default-footer
          >
            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-space-around">
                <v-btn
                  :color="integrationData.DATACADASTRO ? 'red' : 'info'"
                  @click="$emit('verifyIntegrationStatus', item)"
                  x-small
                >
                  <v-icon small>mdi-pin</v-icon>
                </v-btn>
                <v-btn
                  color="warning"
                  class="mx-1"
                  @click="$emit('openIntegrationDataDialog', item)"
                  :disabled="
                    (integrationData && integrationData.ATIVO == 'S') ||
                      !isAdmin
                  "
                  x-small
                >
                  <v-icon small>mdi-pen</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:item.selected="{ item }">
              <span v-if="item.NOME_EMPRESA == integrationData.NOME_EMPRESA">
                <v-icon color="green">mdi-check</v-icon>
              </span>
              <span v-else>
                <v-icon color="red">mdi-close</v-icon>
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <div class="d-flex flex-wrap justify-space-between">
        <v-btn
          :disabled="!integrationData.DATACADASTRO"
          class="mx-1 my-1"
          :color="
            `${
              integrationData.ATIVO && integrationData.ATIVO == 'S'
                ? 'warning'
                : 'info'
            }`
          "
          @click="$emit('runIntegration')"
        >
          <span class="text-caption">{{
            `${
              integrationData.ATIVO && integrationData.ATIVO == 'S'
                ? 'Parar'
                : 'Iniciar'
            }`
          }}</span>
          <v-icon small right>mdi-web</v-icon>
        </v-btn>
        <v-btn
          :disabled="!isAdmin || integrationsList.length > 0"
          class="mx-1 my-1"
          color="success"
          @click="$emit('openIntegrationDataDialog')"
        >
          <span class="text-caption">
            Novo
          </span>
          <v-icon small right>
            mdi-plus-box-multiple
          </v-icon>
        </v-btn>
      </div>
      <v-spacer />
      <v-btn class="mx-1 my-1" color="yellow darken-4">
        <span class="text-caption" @click="$emit('getIntegrations')"
          >Recarregar</span
        >
        <v-icon small right>mdi-refresh</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    showIntegrationDataDialog: false,
    integrationsHeader: [
      { text: 'ID User', value: 'USERNAME' },
      { text: 'Nome Integração', value: 'NOME_EMPRESA' },
      { text: 'Filial', value: 'FILIAL' },
      { text: 'Selecionado', value: 'selected' },
      { text: 'Ações', value: 'actions' },
    ],
  }),
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
      currentSystem: 'systemModule/getCurrentSystem',
    }),

    isAdmin() {
      return this.authUser.NOME === 'SYSDBA'
    },

    cmpIntegrationsList() {
      return this.integrationsList.filter(
        (integ) => integ.FILIAL == this.currentSystem.CODIGO
      )
    },
  },
  props: {
    integrationData: {
      type: Object,
      default: () => {},
    },
    integrationsList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$emit('getIntegrations')
  },
}
</script>

<style></style>
